import { connect } from 'react-redux';
import { Form, FormRenderProps } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getDictionariesKnoOrganizationsSelectOptions,
  makeGetFilteredFederalLawsSelectOptions,
} from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import {
  getAccountOrganizationsWithDistrictData,
  getAccountProsecutorOrganizationsWithDistrictSelectOptions,
} from 'CorePackage/AccountModule/selectors/accountSelectors';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { IUserOrganisation } from 'APIPackage/AccountModule/interfaces/IUserOrganisation';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

import { validateCreateErpModal } from './validate';
import { FormModal } from './FormModal';

export interface ICreatePreventionModalProps {
  onClose: () => void;
  onSaveButtonClick: (values: ICreatePreventionForm) => void;
  visible: boolean;
  invalidFields?: string[];
}

export interface ICreatePreventionModalRenderStoreProps {
  knoOrganizationsSelectOptions: IDictionarySelectOption<IKnoOrganizationDictionary>[] | undefined;
  federalLawsSelectOptions: IDictionarySelectOption<IFederalLawErvk>[] | undefined;
  userProsecutorOrganisationsSelectOptions: IUserOrganisationSelectOption[];
  userKnoOrganisations: IUserOrganisation[];
}

const CreatePreventionModalWithoutStore = ({
  visible,
  onSaveButtonClick,
  knoOrganizationsSelectOptions,
  federalLawsSelectOptions,
  userProsecutorOrganisationsSelectOptions,
  onClose,
  userKnoOrganisations,
}: ICreatePreventionModalProps & ICreatePreventionModalRenderStoreProps) => {
  const handleSubmit = (values: ICreatePreventionForm) => {
    onSaveButtonClick(values);
  };

  const renderForm = (props: FormRenderProps<ICreatePreventionForm, Partial<ICreatePreventionForm>>) => {
    return (
      <FormModal
        {...props}
        knoOrganizationsSelectOptions={knoOrganizationsSelectOptions}
        federalLawsSelectOptions={federalLawsSelectOptions}
        userProsecutorOrganisationsSelectOptions={userProsecutorOrganisationsSelectOptions}
        onClose={onClose}
        visible={visible}
        userKnoOrganisations={userKnoOrganisations}
      />
    );
  };

  if (visible) {
    return (
      <Form<ICreatePreventionForm>
        render={renderForm}
        onSubmit={handleSubmit}
        mutators={{ ...arrayMutators }}
        validate={validateCreateErpModal}
      />
    );
  }

  return null;
};

const mapStateToProps = (state: IRootState): ICreatePreventionModalRenderStoreProps => {
  const getFilteredFederalLawsSelectOptions = makeGetFilteredFederalLawsSelectOptions({ isPm: true });

  return {
    knoOrganizationsSelectOptions: getDictionariesKnoOrganizationsSelectOptions(state),
    federalLawsSelectOptions: getFilteredFederalLawsSelectOptions(state),
    userProsecutorOrganisationsSelectOptions: getAccountProsecutorOrganizationsWithDistrictSelectOptions(state),
    userKnoOrganisations: getAccountOrganizationsWithDistrictData(state).kno,
  };
};

export const CreatePreventionModal = connect(mapStateToProps)(CreatePreventionModalWithoutStore);
